import * as angular from "angular";
import {Observable} from "rxjs";
import {tap} from "rxjs/operators";
import {BatchRecoveryHttpService} from "../angular/services/batch-recovery-http.service";
import {BatchAlertsService} from "./batch-alerts.service";
import {IAMPermissionsService} from "../../../permission/iamPermissions.service";
import {BatchTypeEnum} from "../enums/batch-type.enum";
import {RecoveryActionEnum} from "../enums/recovery-action.enum";
import {BatchProcessTrackingModel} from "../models/batch-process-tracking.model";
import {ProcessTrackingModel} from "../../commons/models/process-tracking.model";
import {BatchRecoveryOptionsModel} from "../models/batch-recovery-options.model";

export class BatchRecoveryService {

  private RECOVER_PERMISSION: string = 'batch.recover';

  /* @ngInject */
  constructor(private batchRecoveryHttpService: BatchRecoveryHttpService,
              private batchAlertsService: BatchAlertsService,
              private IAMPermissions: IAMPermissionsService) {
  }

  canRecover(): boolean {
    return this.IAMPermissions.hasPermission(this.RECOVER_PERMISSION);
  }

  isCandidate(process: ProcessTrackingModel, batchTypes?: BatchTypeEnum[]): boolean {
    const batchProcess = process as BatchProcessTrackingModel;

    return !!batchProcess?.batchId
      && (batchProcess.stalled || batchProcess.awaitingRecovery)
      && (!batchTypes || batchTypes.indexOf(batchProcess.batchType) > -1);
  }

  getOptions(batchId: string): Observable<BatchRecoveryOptionsModel> {
    return this.batchRecoveryHttpService.getRecoveryOptions(batchId).pipe(
      tap({error: (err) => this.batchAlertsService.batchRecoveryError(err?.error ?? err)})
    );
  }

  execute(action: RecoveryActionEnum, batchId: string): Observable<void> {
    const request$ = action === RecoveryActionEnum.RETRY ? this.batchRecoveryHttpService.retry(batchId)
      : action === RecoveryActionEnum.SKIP ? this.batchRecoveryHttpService.skip(batchId)
        : this.batchRecoveryHttpService.cancel(batchId);

    return request$.pipe(tap({
      next: () => this.batchAlertsService.batchRecoverySuccess(),
      error: (err) => this.batchAlertsService.batchRecoveryError(err?.error ?? err)
    }));
  }
}

angular
  .module('bringoz.admin.batch')
  .service('batchRecoveryService', BatchRecoveryService);
